const initialState = {
  users: {
    data: [],
    loading: true,
    error: null,
    total: 0,
  },
  addNewUser: {
    loading: false,
    error: null,
  },
  editUser: {
    data: {},
    loading: false,
    error: null,
  },
};

export default initialState;
